import React from "react";
import { ChartCardStyled, TitleBlock, TitleText, SubtitleText } from "../Dashboard.styles";

// Plain SbCard (antd Card) with a two-line title block — used as the shell
// around every chart/ranked-bars section on the dashboard.
const ChartCard = ({ title, subtitle, children }) => (
  <ChartCardStyled
    size="small"
    styles={{ header: { background: "#F7F7F7" } }}
    title={
      <TitleBlock>
        <TitleText>{title}</TitleText>
        {subtitle && (
          <SubtitleText type="secondary">
            {subtitle}
          </SubtitleText>
        )}
      </TitleBlock>
    }
  >
    {children}
  </ChartCardStyled>
);

export default ChartCard;
